import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { fadeLeft, fadeRight } from '../../animations/animations';
import { CommonModule } from '@angular/common';
import { MMIconsModule } from 'mm-ui';

@Component({
  standalone: true,
  selector: 'mm-float-menu',
  templateUrl: './float-menu.component.html',
  styleUrls: ['./float-menu.component.scss'],
  animations: [fadeLeft, fadeRight],
  imports: [
    CommonModule,
    MMIconsModule
  ],
})
export class FloatMenuComponent implements OnInit, OnChanges {

  @Input('show') show: boolean;
  @Input('close-menu') closeMenu:boolean
  @Output('close') close = new EventEmitter();
  @Input('headerColor') headerColor = 'third'

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.closeMenu && changes.closeMenu.currentValue){
        this.close.emit(changes.closeMenu.currentValue);
    }
  }

}
